import * as wizeMobileApi from '@wize-mobile-api';
import { EDocument, EDocumentsCategory, EDocumentsMedia } from '@qvs/core';
import { DateUtils } from '~/shared/utils/date.utils';
import { environment } from '#environment';
import { customEDocumentCategoryMap } from '~/modules/e-documents/customEDocumentCategoryMap';

export class EDocumentsMapper {
  public static readonly fromWizeEDocumentsCategory = (
    wizeEDocumentsCategory: wizeMobileApi.EDocumentCategorieDTO
  ): EDocumentsCategory | undefined => {
    if (!wizeEDocumentsCategory) {
      return undefined;
    }
    const { subcategories, name, ...additionalProps } = wizeEDocumentsCategory;
    return {
      ...(subcategories ? { subcategories: EDocumentsMapper.fromWizeEDocumentsCategories(subcategories) } : {}),
      name: EDocumentsMapper.getCategoryName(name),
      ...additionalProps
    };
  };

  public static readonly fromWizeEDocumentsCategories = (
    wizeEDocumentsCategories: wizeMobileApi.EDocumentCategorieDTO[]
  ): EDocumentsCategory[] =>
    wizeEDocumentsCategories
      ? wizeEDocumentsCategories
          .filter(
            (wizeEDocumentsCategory) =>
              !environment.featureFlags.customEDocumentCategoryMapping ||
              customEDocumentCategoryMap.hasOwnProperty(wizeEDocumentsCategory.name)
          )
          .map((wizeEDocumentsCategory) => EDocumentsMapper.fromWizeEDocumentsCategory(wizeEDocumentsCategory))
      : undefined;

  public static readonly fromWizeEDocument = (wizeEDcoument: wizeMobileApi.EDocumentMobileDTO): EDocument | undefined => {
    if (!wizeEDcoument) {
      return undefined;
    }
    const { creationDate, documentDate, media, category, subcategory, ...additionalProps } = wizeEDcoument;
    return {
      creationDate: DateUtils.new(creationDate).startOf('day').toDate(),
      documentDate: DateUtils.new(documentDate).startOf('day').toDate(),
      media: EDocumentsMapper.fromWizeEDocumentsMediaJson(media),
      category: EDocumentsMapper.getCategoryName(category),
      subcategory: EDocumentsMapper.getCategoryName(subcategory),
      ...additionalProps
    };
  };

  public static readonly fromWizeEDocuments = (wizeEDocuments: wizeMobileApi.EDocumentMobileDTO[]): EDocument[] =>
    wizeEDocuments ? wizeEDocuments.map((wizeEDocument) => EDocumentsMapper.fromWizeEDocument(wizeEDocument)) : undefined;

  public static readonly fromWizeEDocumentsMediaJson = (wizeEDcoumentsMediaJson: any): EDocumentsMedia | undefined => {
    if (!wizeEDcoumentsMediaJson) {
      return undefined;
    }
    const { media, ...additionalProps } = wizeEDcoumentsMediaJson;
    return {
      base64: media.base64Content,
      ...additionalProps
    };
  };

  private static getCategoryName(name: string): string {
    return environment.featureFlags.customEDocumentCategoryMapping ? customEDocumentCategoryMap[name] : name;
  }
}
